import { Component, OnInit, Inject, Input } from '@angular/core';
import { FileUploader, FileItem, ParsedResponseHeaders, FileUploadModule } from 'ng2-file-upload';
import { SharedService } from '../../services/shared.service';
import { TranslocoService } from '@ngneat/transloco';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material/material.module';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
  standalone: false
})
export class FileUploadComponent implements OnInit {

  @Input() SuccessResponse!: (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => void;
  @Input() onItemRemoved!: (item: FileItem) => void;
  @Input() onBeforeUpload!: (item: FileItem) => void;
  @Input() onCompleteItem!: (item: FileItem) => void;
  @Input() uploadUrl!: string;

  public uploader!: FileUploader;
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;

  constructor(
    @Inject('api_url') private apiUrl: string,
    private sharedService: SharedService,
    private translocoService: TranslocoService) { }



  ngOnInit() {
    this.uploader = new FileUploader({
      url: this.apiUrl + this.uploadUrl,
      headers: [{ name: 'Authorization', value: 'Bearer ' + this.sharedService.authenticationQuery.tokenInfo.access_token }]
    });
    this.uploader.onSuccessItem = (item, response, status, headers) => this.SuccessResponse(item, response, status, headers);
    this.uploader.onAfterAddingFile = (fileItem) => this.onAfterAddingFile(fileItem);
    this.uploader.onBeforeUploadItem = (fileItem) => this.onBeforeUpload(fileItem);
    this.uploader.onCompleteItem = (fileItem) => this.onCompleteItem(fileItem);
  }

  get uploadFilesText() {
    return this.translocoService.translate('Upload Files');
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;

  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    const data = JSON.parse(response);
    console.log(data);
  }

  onAfterAddingFile(fileItem: FileItem) {
    fileItem.withCredentials = false;
    this.uploader.uploadAll();
  }

  remove(item: FileItem) {
    this.onItemRemoved(item);
    item.remove();
  }

}
